import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { facilityGroupsKey } from '@services/useFacilityGroupsQuery';

import type { ISaveGroupData } from '../model/saveFacilityGroup';

const saveTemplateFn = (data: ISaveGroupData) => {
  const sendData = {
    name: data.name,
    location_ids: data.location_ids,
  };
  if (data.id) {
    return apiClient.put(`${APP_API_URL_V2}fsd/facility-location-group/${data.id}`, sendData);
  }

  return apiClient.post(`${APP_API_URL_V2}fsd/facility-location-group`, sendData);
};

export const useCreateEditFacilityGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveTemplateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [facilityGroupsKey()][0] });
    },
  });
};
